module.exports = __webpack_public_path__ + "img/Strategies_1.e8185b16.png";